import AccessManagementUser from './AccessManagementUser';

export default AccessManagementUser;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/AccessManagement/AccessManagementUser/index.js